if (!customElements.get("ld-app-download")) {
  customElements.define(
    "ld-app-download",
    class LdAppDownload extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth <= 768;
      }

      initSwiperDesktop() {
        const wrapper = this;
        const collapseItems = wrapper.querySelectorAll(".collapse-item");
        const firstItem = collapseItems[0];
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          effect: "fade",
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          on: {
            slideChange: () => {
              collapseItems.forEach((prev) => {
                prev.classList.remove("active");
                prev.querySelector(".ci-content").style.height = "0px";
              });
              const item = collapseItems[swiper_2.activeIndex];
              const contentHeight = item.querySelector(".ci-content p").getBoundingClientRect().height;
              item.classList.toggle("active");
              item.querySelector(".ci-content").style.height = `${contentHeight}px`;
            },
          },
        });
        firstItem.classList.add("active");
        firstItem.querySelector(".ci-content").style.height = firstItem.querySelector(".ci-content p").getBoundingClientRect().height + "px";
        collapseItems.forEach((item, index) => {
          item.querySelector(".ci-header").addEventListener("click", () => {
            collapseItems.forEach((prev) => {
              prev.classList.remove("active");
              prev.querySelector(".ci-content").style.height = "0px";
            });
            const contentHeight = item.querySelector(".ci-content p").getBoundingClientRect().height;
            item.classList.toggle("active");
            item.querySelector(".ci-content").style.height = `${contentHeight}px`;
            swiper_2.slideTo(index);
          });
        });
      }

      initSwiperMobile() {
        const wrapper = this;

        const swiper_1 = new Swiper(wrapper.querySelector(".swiper-1"), {
          spaceBetween: 16,
          slidesPerView: 1.15,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          spaceBetween: 16,
          slidesPerView: 1.15,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
          },
        });
        swiper_1.controller.control = swiper_2;
        swiper_2.controller.control = swiper_1;
      }

      connectedCallback() {
        if (this.isMobile) {
          this.initSwiperMobile();
        } else {
          this.initSwiperDesktop();
        }
      }
    }
  );
}
